import { useTranslation } from "#hooks";
import { Translations } from "#interfaces";
import { bp } from "#shared/theme";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { ChartContainer } from "../ChartContainer/ChartContainer";
import { InfoItemProps } from "../Info/Info";
import { SingleChartDesktop } from "../SingleChartDesktop/SingleChartDesktop";
import { SingleChartMobile } from "../SingleChartMobile/SingleChartMobile";

export const MotoChart: React.FC = () => {
  const { t } = useTranslation("tour");
  const labels = t("MotoChart") as Translations;
  const isDesktop = useMediaQuery({ query: bp.m });
  return (
    <ChartContainer
      title={labels.title}
      tooltipContent={labels.tooltip}
      list={(labels.info as unknown) as InfoItemProps[]}
    >
      {isDesktop ? <SingleChartDesktop labels={labels} /> : <SingleChartMobile labels={labels} />}
    </ChartContainer>
  );
};
